import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import { PrimaryButton } from "components/ui/primary-button";
import { SecondaryButton } from "components/ui/secondary-button";
import { Spinner } from "components/ui/spinner";
import { EmailMarketingListOption } from "generated/graphql";
import React, { useState } from "react";

export interface EmailProviderListSelectionDialogProps {
    providerDisplayName: string;
    isOpen: boolean;
    lists: EmailMarketingListOption[];
    isLoading?: boolean;
    onDismiss: () => void;
    onSelectList: (listId: string) => void;
}

export const EmailProviderListSelectionDialog: React.FC<
    EmailProviderListSelectionDialogProps
> = ({
    providerDisplayName,
    isOpen,
    lists,
    isLoading = false,
    onDismiss,
    onSelectList,
}) => {
    const [selectedListId, setSelectedListId] = useState<string>("");

    const handleSync = () => {
        if (selectedListId) {
            onSelectList(selectedListId);
        }
    };

    return (
        <Panel
            type={PanelType.medium}
            onDismiss={onDismiss}
            isOpen={isOpen}
            headerText={`Select ${providerDisplayName} List`}>
            <div className="space-y-4">
                <p className="text-sm text-gray-600">
                    Choose which {providerDisplayName} list you&apos;d like to sync your
                    contacts to:
                </p>

                <div className="space-y-2">
                    {lists.map(list => (
                        <label
                            key={list.id}
                            className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                            <input
                                type="radio"
                                name={`${providerDisplayName}-list`}
                                value={list.id}
                                checked={selectedListId === list.id}
                                onChange={e => setSelectedListId(e.target.value)}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                            />
                            <div className="flex-1">
                                <div className="text-sm font-medium text-gray-900">
                                    {list.name}
                                </div>
                                <div className="text-xs text-gray-500">
                                    {list.memberCount} members
                                </div>
                            </div>
                        </label>
                    ))}
                </div>

                <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
                    <SecondaryButton onClick={onDismiss}>Cancel</SecondaryButton>
                    <PrimaryButton
                        onClick={handleSync}
                        disabled={!selectedListId || isLoading}>
                        {isLoading ? (
                            <div className="flex items-center space-x-2">
                                <Spinner />
                                <span>Syncing...</span>
                            </div>
                        ) : (
                            "Sync to List"
                        )}
                    </PrimaryButton>
                </div>
            </div>
        </Panel>
    );
};
